<div class="modal-header">
  <div>
    <h5 class="modal-title mb-0">
      {{ field ? 'ველის რედაქტირება' : 'ველის დამატება' }}
    </h5>
    <div class="text-muted small">
      შეავსე ველის პარამეტრები და მიუთითე რომელ ფორმის გვერდზე დაემატოს.
    </div>
  </div>

  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" [formGroup]="form">


  <!-- FIELD SETTINGS -->
  <div class="row g-3">

    <div class="col-md-4">
      <div class="form-floating">
        <select class="form-select" id="typeSelect" formControlName="type">
          <option *ngFor="let t of types" [value]="t">{{ t }}</option>
        </select>
        <label for="typeSelect">ველის ტიპი</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-floating">
        <input class="form-control" id="nameInput" formControlName="name" placeholder="email, fullname..." />
        <label for="nameInput">Key (უნიკალური სახელი)</label>
      </div>
      <div class="text-muted small mt-1">
        მაგალითად: <code>email</code>, <code>fullname</code>, <code>phone</code>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-floating">
        <select class="form-select" id="requiredSelect" formControlName="required">
          <option [ngValue]="0">არა</option>
          <option [ngValue]="1">კი</option>
        </select>
        <label for="requiredSelect">სავალდებულოა?</label>
      </div>
    </div>

    <div class="col-12">
      <div class="form-floating">
        <input class="form-control" id="labelInput" formControlName="label" placeholder="Label" />
        <label for="labelInput">Label (მომხმარებელზე რაც გამოჩნდება)</label>
      </div>
    </div>

    <div class="col-12">
      <div class="form-floating">
        <input class="form-control" id="placeholderInput" formControlName="placeholder" placeholder="Placeholder" />
        <label for="placeholderInput">Placeholder</label>
      </div>
    </div>

    <div class="col-12" *ngIf="['select','radio','checkbox'].includes(form.value.type)">
      <div class="form-floating">
        <textarea class="form-control" id="optionsTextarea" rows="6" formControlName="options" style="height: 170px"></textarea>
        <label for="optionsTextarea">Options (თითო ხაზი = ერთ ვარიანტს)</label>
      </div>
      <div class="text-muted small mt-1">
        მაგალითი:<br />
        Option 1<br />
        Option 2<br />
        Option 3
      </div>
    </div>

  </div>
</div>

<div class="modal-footer d-flex justify-content-between">
  <button class="btn btn-light" (click)="activeModal.dismiss()">დახურვა</button>

  <button class="btn btn-primary" (click)="save()" [disabled]="saving || !form.valid">
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
    შენახვა
  </button>
</div>